import React from 'react';
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../../i18n/namespaces";
import { ViewerControlTooltip } from "../../tooltip";
import { ViewerControlButton } from "../button";
import '@isyc-react/design/main';
export const ViewerControlButtonPositionRotate = props => {
  const {
    disabled,
    onRotate,
    rotation
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.rotate')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: disabled,
    onClick: () => onRotate(rotation === 270 ? 0 : rotation + 90)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-rotate-right"
  })));
};